import { render, staticRenderFns } from "./novelinfo.vue?vue&type=template&id=0a7fbf1a"
import script from "./novelinfo.vue?vue&type=script&lang=js"
export * from "./novelinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports